import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ClientReportService } from '../../../service/client-report/client-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'wa1013.component.html',
  styleUrls: ['wa1013.component.css']
})
export class Wa1013Component implements OnInit {
  public componentTitle = 'WA1013:入荷予定・商品ラベル選択';
  public updprogramCd = 'WA1013';

  public working = false;
  public height = 500;
  public production = environment.production;
  public backgroundColor: string;

  public printTypeCd;
  public printNumTypeCd;
  private selectIds: object[];
  private errorInfo = '';

  constructor(private router: Router, private clientReportService: ClientReportService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.height = window.innerHeight - 80;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit(): void {
    this.selectIds = JSON.parse(sessionStorage.getItem('wa1010-arriveplanId-itemLabel'));
  }

  onResize(event) {
    this.height = event.target.innerHeight - 80;
  }

  onSubmit() {
    if (this.printTypeCd === undefined) {
      this.errorInfo = '出力内容を選択してください';
      return;
    }
    if (this.printNumTypeCd === undefined) {
      this.errorInfo = '出力枚数を選択してください';
      return;
    }
    this.working = true;
    let ownerId = 0;
    let reportCd = '';
    switch (this.printTypeCd) {
      case '1':
        reportCd = 'RA9021';
        break;
      case '2':
        reportCd = 'RA9022';
        break;
      case '3':
        reportCd = 'RA9023';
        break;
      case '4':
        reportCd = 'RA9024';
        break;
      default:
        this.working = false;
        this.errorInfo = '予期せぬエラー：未定義の出力内容です';
        return;
    }
    this.clientReportService
      .post2(ownerId, reportCd, '', 1, this.printNumTypeCd, this.updprogramCd, this.selectIds)
      .then(outputJson => {
        this.working = false;
        sessionStorage.removeItem('wa1010-arriveplanId-itemLabel');
        this.router.navigate(['wa1010']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1013/wa1013.component.ts